var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "color-type" }, [_c('span', { staticClass: "name" }, [_vm._v("\n          " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.modelColor, expression: "modelColor" }], staticClass: "value", domProps: { "value": _vm.modelColor }, on: { "input": function input($event) {
        if ($event.target.composing) return;_vm.modelColor = $event.target.value;
      } } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };